import(/* webpackMode: "eager" */ "/vercel/path0/app/(public)/careers/page.tsx");
